import * as v from 'valibot';
import Ajax from '../util/ajax';
import { nexaTransmitterSchema } from '../types/NexaTransmitter';
import { nexaTransmitterUpdated } from '../reducers/nexaTransmittersSlice';
export function saveNexaTransmitter(t, okCallback, errorCallback) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/nexa-transmitter/' + t.id;
        ajax.post(url, t, data => {
            const res = v.safeParse(nexaTransmitterSchema, data);
            if (res.success) {
                dispatch(nexaTransmitterUpdated(res.output));
                okCallback();
            }
            else {
                console.error(v.summarize(res.issues));
                if (errorCallback != undefined) {
                    errorCallback();
                }
            }
        });
    };
}
